import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoFeatureGrid } from "@/components/seo/SeoFeatureGrid";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { Code, Cpu, Wifi, Zap } from "lucide-react";

const WystepKonferencjaIT = () => (
  <SeoPageLayout title="Występ komediowy na" titleAccent="konferencji IT">
    <SeoSection title="Stand-up na konferencji IT i technologicznej">
      <p>Konferencje IT to wydarzenia pełne wiedzy, networkingu i intensywnych prezentacji. Profesjonalny występ komediowy na konferencji technologicznej to idealny sposób na przełamanie rutyny slajdów i wykładów. Nasi komicy znają branżę IT od środka - żartują o sprintach, które nigdy się nie kończą, o code review o 17:00 w piątek i o tym, dlaczego "to działa na moim komputerze" to nie jest rozwiązanie problemu.</p>
    </SeoSection>

    <SeoSection title="Kiedy stand-up na konferencji IT?">
      <SeoStyledList items={[
        "After-party konferencji technologicznych",
        "Przerwa lunchowa między sesjami merytorycznymi",
        "Wieczorna gala i networking",
        "Keynote otwierający lub zamykający konferencję",
        "Hackathony i meetupy branżowe",
        "Wewnętrzne demo days i tech talks"
      ]} />
    </SeoSection>

    <SeoSection title="Humor dopasowany do branży IT">
      <SeoFeatureGrid features={[
        { icon: Code, title: "Agile & Scrum", description: "Żarty o daily standupach, retrospektywach i wiecznych sprintach." },
        { icon: Wifi, title: "Praca zdalna", description: "Obserwacje o home office, Zoomie i korporacyjnym Slacku." },
        { icon: Cpu, title: "AI & Trendy", description: "Humorystyczne spojrzenie na AI, blockchain i buzzwordy technologiczne." },
        { icon: Zap, title: "Kultura dev", description: "Code review, deploy piątkowy, Stack Overflow i firmowe legacy code." },
      ]} />
    </SeoSection>

    <SeoSection title="Zamów komika na konferencję IT">
      <p>Organizujesz konferencję technologiczną, meetup czy hackathon? Skontaktuj się z nami - zaproponujemy komika, który mówi językiem Twojej branży i sprawi, że uczestnicy będą wspominać Twoje wydarzenie nie tylko z powodu świetnych prelekcji.</p>
      <SeoHighlightBox icon={Code}>
        Nasi komicy znają różnicę między frontend a backend - i potrafią z tego zrobić świetny materiał komediowy!
      </SeoHighlightBox>
    </SeoSection>
  </SeoPageLayout>
);

export default WystepKonferencjaIT;
